module.exports = __webpack_public_path__ + "img/info-seven-top-3.7d234c9d.png";